const url = `https://the-delta-times-server.vercel.app/api/news/category`;

export { url };
